import { useQuery } from 'react-query';

import { FeedbackGetResponseDto } from '../../../../backend/src/feedback/dto/get-feedback.response.dto';
import { QueryEntity } from '../types';
import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig from '@/api/useGetFetchConfig';

export function useGetOrganisationFeedback(organisationId: string | undefined) {
  const { fetchConfigGET } = useGetFetchConfig();

  return useQuery<FeedbackGetResponseDto[]>(
    [QueryEntity.OrganisationFeedback, organisationId],
    async () => {
      const res = await fetch(`${APIBaseChronos}/api/feedback/organisation/${organisationId}`, fetchConfigGET);
      return await res.json();
    },
    {
      enabled: !!organisationId,
      refetchOnWindowFocus: false,
    },
  );
}
